export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[92vh] flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=minimal%20editorial%20investigation%20board%20made%20of%20warm%20paper%20notes%20and%20thin%20red%20threads%20connecting%20documents%20on%20a%20light%20cork%20surface%2C%20soft%20diffused%20morning%20light%2C%20warm%20cream%20and%20clay%20tones%2C%20lots%20of%20negative%20space%2C%20clean%20calm%20composition%2C%20abstract%20documentary%20aesthetic%20with%20no%20people&width=1600&height=1000&seq=cg51-hero-2026&orientation=landscape"
          alt="cg51 吃瓜线索追踪看板"
          title="cg51 吃瓜线索深挖看板"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70" />
      </div>

      <div className="relative z-10 flex w-full flex-1 items-center justify-center px-4 pb-16 pt-28 md:pt-32">
        <div className="w-full max-w-4xl text-center">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            持续追踪中 · 今日已归档 3 条
          </p>

          <h1 className="font-heading text-3xl leading-snug font-bold text-background-50 md:text-5xl md:leading-tight">
            吃瓜线索深挖，
            <br className="md:hidden" />
            不追到实锤不收手
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            一份自组织的公开追踪站：把线索收进表、把来源做交叉、把反转写进复盘。
            cg51 以克制的方式记录每一场讨论如何从猜疑走向结论，再被证据推翻。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-time-line text-base" />
              查看焦点时间线
            </a>
            <a
              href="#evidence"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 backdrop-blur transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              浏览实锤库
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </div>
      </div>

      <div className="relative z-10 border-t border-background-50/15 bg-foreground-950/40 px-4 py-4 backdrop-blur">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 text-xs text-background-100 sm:flex-row md:px-6">
          <div className="flex items-center gap-2">
            <i className="ri-flag-2-line text-accent-400" />
            <span>本周重点关注：#0721 实锤标准 · 时间戳之争</span>
          </div>
          <p className="whitespace-nowrap text-background-200">
            线索 39 · 已核验 16 · 存疑 5 · 复盘 7
          </p>
        </div>
      </div>
    </section>
  );
}